/**
 * Helper class for detecting swipe events
 *
 * @export
 * @class Swipe
 */
export class Swipe {
    private events: SwipeEvents;
    private xDown: number | null = null;
    private yDown: number | null = null;


    /**
     * Creates an instance of Swipe.
     *
     * @param {SwipeEvents} events The event callbacks.
     * @memberof Swipe
     */
    constructor(events: SwipeEvents) {
        this.events           = events;
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove  = this.handleTouchMove.bind(this);

        document.addEventListener('touchstart', (event) => {
            this.handleTouchStart(event);
        }, false);
        document.addEventListener('touchmove',  (event) => {
            this.handleTouchMove(event);
        }, false);
    }


    /**
     * Fires when the user swipes left
     *
     * @memberof Swipe
     */
    public onLeft() {
        if(this.events.onLeft) this.events.onLeft();
    }


    /**
     * Fires when the user swipes right
     *
     * @memberof Swipe
     */
    public onRight() {
        if(this.events.onRight) this.events.onRight();
    }


    /**
     * Fires when the user swipes up
     *
     * @memberof Swipe
     */
    public onUp() {
        if(this.events.onUp) this.events.onUp();
    }


    /**
     * Fires when the user swipes down
     *
     * @memberof Swipe
     */
    public onDown() {
        if(this.events.onDown) this.events.onDown();
    }


    /**
     * Returns the event touches object
     *
     * @static
     * @param {TouchEvent} evt The event object
     * @returns
     * @memberof Swipe
     */
    static getTouches(evt: TouchEvent) {
        return evt.touches;
    }


    /**
     * On touch start, set the initial touch start x and y
     *
     * @param {TouchEvent} evt The event object.
     * @memberof Swipe
     */
    handleTouchStart(evt: TouchEvent) {
        const firstTouch = Swipe.getTouches(evt)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;
    }


    /**
     * On swipe move, calculate the direction of the swipe by comparing them to the previous values.
     *
     * @param {TouchEvent} evt
     * @returns
     * @memberof Swipe
     */
    handleTouchMove(evt: TouchEvent) {
        if ( ! this.xDown || ! this.yDown ) {
            return;
        }

        // Determines the swipe direction and fires the corresponding event
        const xUp = evt.touches[0].clientX;
        const yUp = evt.touches[0].clientY;
        const xDiff = this.xDown - xUp;
        const yDiff = this.yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
            if ( xDiff > 0 && this.events.onLeft) {
                this.onLeft();
            } else if (this.events.onRight) {
                this.onRight();
            }
        } else {
            if ( yDiff > 0 && this.events.onUp) {
                this.onUp();
            } else if (this.events.onDown){
                this.onDown();
            }
        }

        // Reset values
        this.xDown = null;
        this.yDown = null;
    }
}
